<template>
<div class="chapter">
<div class="inner_page">
      ﻿

 <meta charset="utf-8"/> <link href="styles/default.css" rel="stylesheet" type="text/css"/> <title>Volume One</title>
<div class="chapter">
<section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Volume One">
<p class="tx55" id="p0009-01-0">
<a id="page9">
<b>1 </b>
<span class="st1">Compliment three people every day. </span>
</a></p><a id="page9">
<p class="tx55" id="p0009-02-1">
<b>2 </b>
<span class="st1">Have a dog.</span>
</p>
<p class="tx55" id="p0009-02-2">
<b>3 </b>
<span class="st1">Watch a sunrise at least once a year. </span>
</p>
<p class="tx55" id="p0009-P-1">
<b>4 </b>
<span class="st1">Remember other people’s birthdays. </span>
</p>
<p class="tx55" id="p0009-P-2">
<b>5 </b>
<span class="st1">Overtip breakfast waitresses.</span>
</p>
<p class="tx55" id="p0009-02-3">
<b>6 </b>
<span class="st1">Have a firm handshake.</span>
</p>
<p class="tx55" id="p0009-02-4">
<b>7 </b>
<span class="st1">Look people in the eye.</span>
</p>
<p class="tx55" id="p0009-02-5">
<b>8 </b>
<span class="st1">Say “thank you” a lot.</span>
</p>
<p class="tx55" id="p0009-02-6">
<b>9 </b>
<span class="st1">Say “please” a lot.</span>
</p>
</a><p class="tx52" id="p0010-P-1"><a id="page9">
</a><a id="page10">
<b>10 </b>
<span class="st1">Learn to play a musical instrument.</span>
</a></p><a id="page10">
<p class="tx52" id="p0010-P-2">
<b>11 </b>
<span class="st1">Sing in the shower.</span>
</p>
<p class="tx52" id="p0010-01-1">
<b>12 </b>
<span class="st1">Use the good silver.</span>
</p>
<p class="tx52" id="p0010-01-2">
<b>13 </b>
<span class="st1">Learn to make great chili.</span>
</p>
<p class="tx52" id="p0010-01-3">
<b>14 </b>
<span class="st1">Plant flowers every spring.</span>
</p>
<p class="tx52" id="p0010-01-4">
<b>15 </b>
<span class="st1">Own a great stereo system.</span>
</p>
<p class="tx52" id="p0010-01-5">
<b>16 </b>
<span class="st1">Be the first to say, “Hello.”</span>
</p>
<p class="tx52" id="p0010-01-6">
<b>17 </b>
<span class="st1">Live beneath your means.</span>
</p>
<p class="tx52" id="p0010-01-7">
<b>18 </b>
<span class="st1">Buy great books, even if you never read them.</span>
</p>
</a><p class="tx52" id="p0011-P-1"><a id="page10">
<b>19 </b>
<span class="st1">
</span></a><a id="page11">Drive inexpensive cars, but own the best house you can afford.
 </a></p><a id="page11">
<p class="tx52" id="p0011-01-1">
<b>20 </b>
<span class="st1">Be forgiving of yourself and others.</span>
</p>
<p class="tx52" id="p0011-01-2">
<b>21 </b>
<span class="st1">Learn three clean jokes.</span>
</p>
<p class="tx52" id="p0011-01-3">
<b>22 </b>
<span class="st1">Wear polished shoes.</span>
</p>
<p class="tx52" id="p0011-01-4">
<b>23 </b>
<span class="st1">Floss your teeth.</span>
</p>
<p class="tx52" id="p0011-01-5">
<b>24 </b>
<span class="st1">Drink champagne for no reason at all.</span>
</p>
<p class="tx52" id="p0011-P-2">
<b>25 </b>
<span class="st1">Ask for a raise when you feel you’ve earned it.</span>
</p>
<p class="tx52" id="p0011-01-6">
<b>26 </b>
<span class="st1">Buy whatever kids are selling on card tables in their front yard.</span>
</p>
</a><p class="tx52" id="p0012-P-1"><a id="page11">
</a><a id="page12">
<b>27 </b>
<span class="st1">If in a fight, hit first and hit hard.</span>
</a></p><a id="page12">
<p class="tx52" id="p0012-01-1">
<b>28 </b>
<span class="st1">Return all the things you borrow.</span>
</p>
<p class="tx52" id="p0012-01-2">
<b>29 </b>
<span class="st1">Teach some kind of class.</span>
</p>
<p class="tx52" id="p0012-01-3">
<b>30 </b>
<span class="st1">Be a student in some kind of class.</span>
</p>
<p class="tx52" id="p0012-01-4">
<b>31 </b>
<span class="st1">Never buy a house without a fireplace.</span>
</p>
<p class="tx52" id="p0012-01-5">
<b>32 </b>
<span class="st1">Once in your life own a convertible.</span>
</p>
<p class="tx52" id="p0012-P-2">
<b>33 </b>
<span class="st1">Treat everyone you meet like you want to be treated.</span>
</p>
<p class="tx52" id="p0012-01-6">
<b>34 </b>
<span class="st1">Learn to identify the music of Chopin, Mozart, and Beethoven.</span>
</p>
</a><p class="tx52" id="p0013-01-0"><a id="page12">
</a><a id="page13">
<b>35 </b>
<span class="st1">Plant a tree on your birthday.</span>
</a></p><a id="page13">
<p class="tx52" id="p0013-01-1">
<b>36 </b>
<span class="st1">Donate two pints of blood every year.</span>
</p>
<p class="tx52" id="p0013-01-2">
<b>37 </b>
<span class="st1">Make new friends but cherish the old ones.</span>
</p>
<p class="tx52" id="p0013-01-3">
<b>38 </b>
<span class="st1">Keep secrets.</span>
</p>
<p class="tx52" id="p0013-01-4">
<b>39 </b>
<span class="st1">Take lots of snapshots.</span>
</p>
<p class="tx52" id="p0013-01-5">
<b>40 </b>
<span class="st1">Never refuse homemade brownies.</span>
</p>
<p class="tx52" id="p0013-01-6">
<b>41 </b>
<span class="st1">Don’t postpone joy.</span>
</p>
<p class="tx52" id="p0013-01-7">
<b>42 </b>
<span class="st1">Ask someone to pick up your mail and daily paper when you’re out of town. Those are the first two things potential burglars look for.</span>
</p>
</a></section><a id="page13">
</a></div>
<a id="page13">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter4.vue?e0a51494